import React from "react";
import { Doughnut } from "react-chartjs-2";
import { makeStyles, useTheme } from "@material-ui/styles";
import { Card, CardHeader, CardContent, Divider, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {},
  chartContainer: {
    position: "relative",
    height: "300px",
  },
}));

const TalningDoughnut = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { talning, embaetti } = props;
  let chartData = {
    datasets: [
      {
        data: [],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.error.main,
          // theme.palette.warning.main,
          theme.palette.success.main,
          theme.palette.secondary.main,
          theme.palette.info.main
        ],
        borderWidth: 4,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white,
      },
    ],
    labels: ["Í kassa", "Tekið með", /*"Aðsent"*/ "Heilbrigðisstofnun", "Fangelsi", "Heimahúsi"],
  };

  // Push updated data into the chart dataset
  if (talning.heildarfjoldi !== undefined ) {
    chartData.datasets.forEach(dataset => {
      dataset.data.push(talning.heildarfjoldiKassa.alls);
      dataset.data.push(talning.heildarfjoldiTekidMed.alls);
      // dataset.data.push(talning.heildarfjoldiAdsent.alls);
      dataset.data.push(talning.heildarfjoldiHeilbrigdisstofnun.alls);
      dataset.data.push(talning.heildarfjoldiFangelsi.alls);
      dataset.data.push(talning.heildarfjoldiHeimahus.alls);
    });
  }

  const options = {
    legend: {
      display: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: "index",
      intersect: false,
      borderWidth: 1,
    },
  };

  return (
    <Card>
      <CardHeader title="Atkvæði" subheader={embaetti} />
      <Divider />
      <CardContent>
        {talning.heildarfjoldi !== undefined ? (
          <div className={classes.chartContainer}>
            <Doughnut data={chartData} options={options} />
          </div>
        ) : (
          <Typography>Engin gögn fundust</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default TalningDoughnut;
